
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artist/[...param]",
      function () {
        return require("private-next-pages/artist/[...param].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artist/[...param]"])
      });
    }
  